import {createApp} from 'vue';
import {createPinia} from 'pinia';

import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import i18n from '@/i18n';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import VueLazyload from 'vue-lazyload';
// import {useDataStore} from '@/stores/underList';

import './assets/main.css';
// 注册所有图标
import 'virtual:svg-icons-register'; // 引入注册脚本
import SvgIcon from '@/components/SvgIcon/index.vue';
import BaseButton from '@/components/button/baseButton.vue';

const app = createApp(App);
app.use(createPinia());
// useDataStore();
for (const [key, comp] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, comp as any);
}
app.use(ElementPlus, {locale: zhCn});
// app.use(ElementPlus, { locale: en });
app.component('SvgIcon', SvgIcon);
app.component('BaseButton', BaseButton);
app.use(router);
app.use(i18n);
app.use(VueLazyload);

app.mount('#app');
